import axios from 'axios'
import type { CheckVideoLinkPayload, CheckVideoLinkResponse } from '@/types/videoLink'

/** Данные ролика по ссылке для предпросмотра (обложка, название, плеер). */
export const checkVideoLinkApiCall = async (
  abortController?: AbortController,
  params?: CheckVideoLinkPayload,
): Promise<CheckVideoLinkResponse> => {
  const { data } = await axios.post(
    '/dashboard/v1/chief/video-links/check',
    { url: params?.url },
    { signal: abortController?.signal },
  )
  return data
}
